(function () {
  function bindSlider(slider) {
    if (slider.dataset.zeusBaBound === "true") return;
    const handle = slider.querySelector(".ba-handle");
    const after = slider.querySelector(".ba-after");
    if (!handle || !after) return;
    slider.dataset.zeusBaBound = "true";

    let dragging = false;

    function update(clientX) {
      const rect = slider.getBoundingClientRect();
      if (!rect.width) return;
      let pos = ((clientX - rect.left) / rect.width) * 100;
      pos = Math.max(0, Math.min(100, pos));
      handle.style.left = pos + "%";
      after.style.clipPath = "inset(0 0 0 " + pos + "%)";
    }

    slider.addEventListener("mousedown", (e) => {
      dragging = true;
      update(e.clientX);
    });
    window.addEventListener("mousemove", (e) => {
      if (dragging) update(e.clientX);
    });
    window.addEventListener("mouseup", () => {
      dragging = false;
    });

    slider.addEventListener(
      "touchstart",
      (e) => {
        dragging = true;
        if (e.touches && e.touches[0]) update(e.touches[0].clientX);
      },
      { passive: true }
    );
    window.addEventListener(
      "touchmove",
      (e) => {
        if (dragging && e.touches && e.touches[0]) update(e.touches[0].clientX);
      },
      { passive: true }
    );
    window.addEventListener("touchend", () => {
      dragging = false;
    });
  }

  function initZeusBaSliders() {
    document.querySelectorAll("[data-zeus-ba-slider]").forEach(bindSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initZeusBaSliders);
  } else {
    initZeusBaSliders();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target;
    if (!root || !root.querySelectorAll) return;
    const sliders = root.querySelectorAll("[data-zeus-ba-slider]");
    if (!sliders.length) return;
    sliders.forEach((el) => {
      delete el.dataset.zeusBaBound;
    });
    sliders.forEach(bindSlider);
  });
})();
